import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useWallet } from '../hooks/useWallet';
import WalletModal from './WalletModal';
import './Nav.css';

const AmitisLogo = () => (
  <svg width="28" height="28" viewBox="0 0 320 320" xmlns="http://www.w3.org/2000/svg">
    <circle cx="160" cy="160" r="155" fill="#080810"/>
    <circle cx="160" cy="160" r="155" fill="none" stroke="white" strokeWidth="6"/>
    <text x="160" y="252" textAnchor="middle" fontFamily="Arial Black, Arial, sans-serif" fontSize="260" fontWeight="900" fill="white">A</text>
    <path d="M248,72 C268,52 288,68 268,88 C258,98 238,92 248,72Z" fill="#4ade80" opacity="0.7"/>
    <line x1="248" y1="72" x2="268" y2="88" stroke="#4ade80" strokeWidth="1.5" opacity="0.5"/>
  </svg>
);

export default function Nav() {
  const location = useLocation();
  const { wallet, balance, disconnect } = useWallet();
  const [showModal, setShowModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  const navLinks = [
    { path: '/', label: 'Dashboard' },
    { path: '/faucet', label: 'Faucet' },
    { path: '/swap', label: 'Swap' },
    { path: '/bridge', label: 'Bridge' },
  ];

  const formatAddress = (addr) => `${addr.slice(0, 10)}...${addr.slice(-6)}`;
  const formatBalance = (bal) => bal !== null ? `${bal.toLocaleString(undefined, { maximumFractionDigits: 2 })} AMTS` : '—';

  return (
    <>
      <nav className="nav">
        <Link to="/" className="nav-brand">
          <AmitisLogo />
          <span className="nav-wordmark">AMITIS</span>
          <span className="nav-tag">Portal</span>
        </Link>

        <ul className="nav-links">
          {navLinks.map(({ path, label }) => (
            <li key={path}>
              <Link
                to={path}
                className={`nav-link ${location.pathname === path ? 'active' : ''}`}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="nav-wallet">
          {wallet ? (
            <div className="wallet-connected" onClick={() => setShowDropdown(!showDropdown)}>
              <div className="wallet-dot" />
              <div className="wallet-info">
                <span className="wallet-address mono">{formatAddress(wallet.address)}</span>
                <span className="wallet-balance">{formatBalance(balance)}</span>
              </div>
              {showDropdown && (
                <div className="wallet-dropdown">
                  <div className="dropdown-address mono">{wallet.address}</div>
                  <div className="dropdown-type">via {wallet.type === 'keplr' ? 'Keplr' : 'Browser Wallet'}</div>
                  <button className="dropdown-disconnect" onClick={(e) => { e.stopPropagation(); disconnect(); setShowDropdown(false); }}>
                    Disconnect
                  </button>
                </div>
              )}
            </div>
          ) : (
            <button className="btn-connect" onClick={() => setShowModal(true)}>
              Connect Wallet
            </button>
          )}
        </div>
      </nav>

      {showModal && <WalletModal onClose={() => setShowModal(false)} />}
    </>
  );
}
